import React from "react";
import { Select } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ls from "./LanguageSelect.module.css";

function normalizeLng(lng) {
  if (!lng) return "ko";
  if (String(lng).toLowerCase().startsWith("en")) return "en";
  return "ko";
}

/**
 * 헤더 등에서 사용하는 언어 선택 (Ant Design Select)
 */
function LanguageSelect({ className, variant = "default" }) {
  const { t, i18n } = useTranslation();
  const value = normalizeLng(i18n.language);

  const options = [
    { value: "ko", label: "한국어" },
    { value: "en", label: "English" },
  ];

  return (
    <div className={ls.wrap}>
      <GlobalOutlined
        className={variant === "compact" ? ls.iconCompact : ls.icon}
        aria-hidden
      />
      <Select
        className={className}
        value={value}
        options={options}
        onChange={(lng) => i18n.changeLanguage(lng)}
        aria-label={t("LANGUAGE.selectLabel")}
        popupMatchSelectWidth={false}
        size={variant === "compact" ? "small" : "middle"}
      />
    </div>
  );
}

export default LanguageSelect;
